import { Component, Inject, OnInit } from '@angular/core';
import { OrderInfoResponse, ScheduleOrderResponse, ScheduleResponse } from '../../../models/schedule.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SchedulesService } from '../../../services/schedules.service';
import { BulkProcessComponent } from '../bulk-process/bulk-process.component';

@Component({
  selector: 'app-start-schedule',
  standalone: true,
  imports: [
    MatDialogModule,
    MatCardModule,
    CommonModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    BulkProcessComponent,
  ],
  templateUrl: './start-schedule.component.html',
  styleUrl: './start-schedule.component.scss'
})
export class StartScheduleComponent implements OnInit{
  schedule!: ScheduleResponse;
  outstandingOrders: ScheduleOrderResponse[] = [];

  constructor(
    public dialogRef: MatDialogRef<StartScheduleComponent>,
    private scheduleService: SchedulesService,
    @Inject(MAT_DIALOG_DATA) public data: { schedule: ScheduleResponse },
  ){}

  ngOnInit(): void {
    this.schedule = this.data.schedule;
    for (let order of this.schedule.orders) {
      if (order.order
         && order.scheduleType === 'Dropoff'
         && order.status !== 'InProgress'
         && order.status !== 'Completed'
         && order.status !== 'Cancelled'
        ) {
        this.outstandingOrders.push(order);
      }
    }
  }

  startSchedule(): void {
    this.scheduleService.startSchedule(this.schedule.id).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.error('Error starting schedule:', error);
      }
    });
  }

}
